// extracted by mini-css-extract-plugin
export default {"contentLeft":"stickyComponent_contentLeft__1TsJD","border":"stickyComponent_border__9y5gd","period":"stickyComponent_period__DlWUa"};